import { configureStore } from "@reduxjs/toolkit";
import aiAgentReducer from "./aiAgentSlice";

export const store = configureStore({
  reducer: {
    aiAgent: aiAgentReducer,
  },
});

// Type helpers
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
